var generateStyle = function generateStyle(componentTheme) {
  return {
    quizShow: {
      padding: "".concat(componentTheme.quizShowPadding, " 0"),
      width: '100%'
    },
    sectionWrapper: {
      boxSizing: 'border-box',
      padding: "".concat(componentTheme.sectionWrapperPadding, " ").concat(componentTheme.sectionWrapperPaddingSide, " ").concat(componentTheme.sectionWrapperPadding, " ").concat(componentTheme.sectionWrapperPaddingSide),
      minHeight: '3.25rem',
      marginBottom: componentTheme.sectionWrapperMargin
    },
    clearfix: {
      '&:after': {
        clear: 'both',
        content: '""',
        display: 'table'
      }
    },
    accessCodeWrapper: {
      '> div': {
        display: 'block',
        marginTop: componentTheme.accessCodeWrapperMargin,
        marginBottom: componentTheme.accessCodeWrapperMargin
      }
    }
  };
};
export default generateStyle;